/**
 * Chevron Right Icon - Right-pointing chevron for navigation
 *
 * Design: 16x16 bold chevron pointing right
 * Usage: Lightbox next button, carousel navigation
 * Color: Inherits from parent (uses currentColor)
 */

export const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 2L11.5 8L5.5 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
